import { Injectable } from '@angular/core';
import {environment} from "environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Promo, PromoDish} from "app/models/menu.model";
import {firstValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PromoApiService {

  private requestPath = `${environment.posBaseUrl}/api/front/promo`;

  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private http: HttpClient,
  ) { }

  public async createOrUpdate(menuId: string, dishes: PromoDish[]) : Promise<Promo>{
    try{
      return await firstValueFrom(
        this.http.post<Promo>(
          this.requestPath + "?menuId=" + menuId,
          dishes,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  public async get(organizationId: string) : Promise<Promo>{
    try{
      return await firstValueFrom(
        this.http.get<Promo>(
          this.requestPath + "?menuId=" + organizationId,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  public async delete(menuId: string) : Promise<number>{
    try{
      return await firstValueFrom(
        this.http.delete<number>(
          this.requestPath + "?menuId=" + menuId,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }
}
